import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import image1 from "../assets/1.jpg";
import image2 from "../assets/2.jpg";
import "./HomeStyle.css";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

const Home = ({ id }) => {
  const { t, i18n } = useTranslation();
  const [currentImage, setCurrentImage] = useState(0);
  const images = [image1, image2];

  const slideUp = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev === 0 ? 1 : 0));
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  const scrollToAppointmentBooking = () => {
    const AppointmentBookingElement =
      document.getElementById("AppointmentBooking");
    if (AppointmentBookingElement) {
      AppointmentBookingElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <main
      className={`hero-section ${i18n.language === "ar" ? "rtl-layout" : ""}`}
      id={id}
    >
      <Helmet>
        <title>Selfie Smile | Family Dental Care in Alexandria</title>
        <meta
          name="description"
          content="Elevating smiles with expert care and a gentle touch. Book your dental appointment today with Selfie Smile in Alexandria."
        />
        <meta
          name="keywords"
          content="Selfie Smile, Dental Clinic, Alexandria Dentist, Family Dental Care, Dr. Ali Obida"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Selfie Smile Dental Clinic" />
        <meta
          property="og:description"
          content="Book your next dental appointment with Selfie Smile. Trusted care for families in Alexandria."
        />
      </Helmet>

      <div className="image-slideshow">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={t(`home.images.alt${index + 1}`)}
            className={`background-image ${
              index === currentImage ? "active" : ""
            }`}
          />
        ))}
      </div>
      <div className="overlay"></div>
      <div className="content">
        <motion.p
          className="sub-text"
          variants={slideUp}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.2 }}
        >
          {t("home.subText")}
        </motion.p>
        <motion.h1
          className="main-title"
          variants={slideUp}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.4 }}
        >
          {t("home.mainTitle")}
        </motion.h1>
        <motion.div
          className="buttons"
          variants={slideUp}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.6 }}
        >
          <button className="btnHome" onClick={scrollToAppointmentBooking}>
            {t("home.buttons.book")}
          </button>
        </motion.div>
      </div>
    </main>
  );
};

export default Home;
